import http from "../../utils/services/http-client";
import urlHelper from "../../utils/urlHelper/UrlHelper";
import {CitiesFilter, RegisterReportModel, UserCities} from "../models";

class SharedService {
  getProductCategoryList() {
    return http.get(`/ProductCategories`);
  }
  getProductSubCategoryList(id:number) {
    return http.get(`/ProductSubCategories?id=`+id);
  }
  getProVince() {
    return http.get(`/Provinces`);
  }
  getCities(model:CitiesFilter) {
    const queryParams = urlHelper(model);
    return http.get(`/Cities?${queryParams}`);

  }
  getUserCities() {
    return http.get(`/UserCities`);
  }
  getProductThumbnail(id:string) {
    return http.get(`/ProductThumbnail?id=` +id);
  }
  getProductImage(id:string) {
    return http.get(`/ProductImages?id=` +id);
  }
  deleteBookmark(id:string) {
    return http.delete(`/Bookmarks/` +id);
  }
  registerUserCities(ids:UserCities) {
    return http.put(`/UserCities`,ids);
  }
  registerReport(model:RegisterReportModel) {
    return http.post(`/Reports`,model);
  }
  getUser() {
    return http.get(`/CurrentUser`);
  }
  verifyIdentity(nationalCode:number) {
    return http.put(`/VerifyIdentity`,nationalCode);
  }
  uploadImage(model:any) {
    return http.post(`/UploadProductImage`,model);
  }
  downloadContract(id:any) {
    return http.get("/BorrowRequest/DownloadContract/"+id, {
      responseType: "arraybuffer",
      validateStatus: () => true,
      headers: {
        Accept: "application/pdf",
        "X-Requested-With": "XMLHttpRequest", // Prevent IDM from hijacking
      },
    }).then(res => {
      if (res.status === 204) throw new Error("NO_CONTENT");

      const contentType = res.headers["content-type"] || "";
      if (!contentType.includes("application/pdf")) {
        const errText = new TextDecoder().decode(res.data);
        throw new Error(errText);
      }

      return res.data;
    });
  }
  getProductOwner(id:string) {
    return http.get(`/ProductOwner?id=`+id);
  }
  getBanner(model:any) {
    const queryParams = urlHelper(model);
    return http.get(`/ActiveBanners?${queryParams}`);
  }


}

export default new SharedService();
